<template>
  <v-text-field
    v-model="val"
    single-line
    dense
    style="max-width: 230px; margin-left: auto; margin-right: auto"
    :label="dense ? '' : label"
    :hide-details="showMessages"
    :error-messages="errorMessages"
  ></v-text-field>
</template>
<script>
export default {
  name: "SetTimeOutInput",

  props: {
    value: String,
    label: String,
    dot: Number,
    min: Number,
    max: Number,
    dense: Boolean,
    showMessages: Boolean,
    errorMessages: Array,
    allowNegative: Boolean,
    usable: Boolean,
  },

  data: () => ({
    val: null,
    monitorTime: null,
  }),

  watch: {
    value: {
      handler() {
        this.val = this.value;
      },
    },
    val: {
      handler() {
        clearInterval(this.monitorTime);
        this.monitorTime = setTimeout(
          function () {
            this.$emit("input", this.val);
          }.bind(this),
          400
        );
      },
    },
  },

  beforeDestroy() {
    clearInterval(this.monitorTime);
  },
};
</script>